import { Injector, ElementRef, NgZone, ApplicationRef, OnInit } from "@angular/core";
import { DataService } from "./data/data.service";
import { WorkspaceServiceService } from "./workspace-service.service";
import { Workspace } from "../model/workspace.data";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GlobalGridModeService } from "./globalGridMode/globalGridMode.service";
import { WolfieContextMenuService } from "./wolfie-context-menu/wolfie-context-menu.service";
import { ChartInstanceService } from "./chartInstance/chart.instance.service";
import { ChartDisplayModeService } from "./layoutDisplayModeService/layoutDisplayModeService.service";
import { ChartLayoutModeService } from "./chartLayoutMode/chartLayoutMode.service";
import { SymbolTypeService } from "./quoteFilterTabsActiveMode/quoteFilterTabsActiveMode.service";
import { AChartComponent } from "../components/achart/achart.component";
import { QuoteTabsActiveModeService } from "./quoteTabsActiveMode/quoteTabsActiveMode.service";
import { CookiesService } from "../tools/cookies.service";
import { ToastrHelper } from "../components/toastr/toastr";
import { ToastrService } from "ngx-toastr";
import { WakeUpService } from "./wakeUp.service";
import { ShareService } from "./share.service";
import { GoogleAnalyticsService } from "./google-analytics.service";

export abstract class AppComponentBase {
    protected element: ElementRef;
    protected app: ApplicationRef;
    protected dataService: DataService;
    protected workspaceService: WorkspaceServiceService;
    public get workspace (): Workspace {
        return this.workspaceService.data;
    }

    protected modalService: NgbModal;
    protected zone: NgZone;
    protected globaGridMode: GlobalGridModeService;
    protected contextMenuService: WolfieContextMenuService;

    protected chartInstanceService: ChartInstanceService;
    public get selectedChart (): AChartComponent {
        return this.chartInstanceService.selectedChart;
    }

    protected chartDisplayModeService: ChartDisplayModeService;
    protected activeLayoutChartService: ChartLayoutModeService;
    protected symbolTypeService: SymbolTypeService;
    protected activeQuoteTab: QuoteTabsActiveModeService;

    protected cookieService: CookiesService;
    protected toastrHelper: ToastrHelper;
    protected toastr: ToastrService;
    protected wakeUp: WakeUpService;
    protected shareService: ShareService;

    protected gaService: GoogleAnalyticsService;

    constructor ( injector: Injector ) {
        this.element = injector.get( ElementRef );
        this.app = injector.get( ApplicationRef );
        this.dataService = injector.get( DataService );
        this.workspaceService = injector.get( WorkspaceServiceService );
        this.modalService = injector.get( NgbModal );
        //  this.workspace.modalService = injector.get(NgbModal);
        this.zone = injector.get( NgZone );
        this.globaGridMode = injector.get( GlobalGridModeService );
        this.contextMenuService = injector.get( WolfieContextMenuService );
        this.chartInstanceService = injector.get( ChartInstanceService );
        this.chartDisplayModeService = injector.get( ChartDisplayModeService );
        this.activeLayoutChartService = injector.get( ChartLayoutModeService );
        this.symbolTypeService = injector.get( SymbolTypeService );
        this.activeQuoteTab = injector.get( QuoteTabsActiveModeService );
        this.cookieService = injector.get( CookiesService );
        this.toastr = injector.get( ToastrService );
        this.wakeUp = injector.get( WakeUpService );
        this.toastrHelper = new ToastrHelper( this.toastr );
        this.shareService = injector.get( ShareService );

        this.gaService = injector.get( GoogleAnalyticsService );
        this.gaService.sendComponentView( this.constructor.name );

    }

    public forceLogout () {
        this.cookieService.deleteCookie( "_zp" );
        window.location.href = "/";
    }
    /*   protected setToUserStore(name: string,value: string){
        this.workspace.setToUserStore(name,value)
    }

    protected getFromUserStore(name: string): string | null{
        return this.workspace.getFromUserStore(name);
    }*/
}
